import(/* webpackMode: "eager" */ "/vercel/path0/client/src/app/(auth)/auth/page.tsx");
